export interface IQuizView {
  quizId: number
  showResult: boolean
  showQuiz: boolean
  showHome: boolean
}

export interface IWorkplaceQuizModuleState {
  header: string
  body: string
  quizStatus: IWorkplaceQuizState[]
  answers: IQuizOption[]
  glossaries: IGlossary[]
}

export interface IWorkplaceQuizState {
  quizId: number
  title: string
  totalQuestions: number
  correctAnswered: string[]
  wrongAnswered: string[]
  completed: boolean
  failed: boolean
  glossaries: IGlossary[]
  failedResources: IQuestionFailedResource[]
  remainderResources: IQuizResource[]
}

export interface IQuestionFailedResource {
  questionId: string
  resource: IQuizResource
}

export interface IWorkplaceQuizResponse {
  introHeader: string
  introBody: string
  quizzes: IQuiz[]
  glossaries: IGlossary[]
}

export interface IQuiz {
  id: number
  title: string
  image: string
  totalQuestions: number
  remainderResources: IQuizResource[]
}

export class IWorkplaceQuiz {
  introHeader: string
  introBody: string
  quizes: IQuiz[]
}

export class WorkplacQuiz implements IWorkplaceQuiz {
  introHeader = ''
  introBody = ''
  quizes: IQuiz[]
}

export interface IQuizResponse {
  id: number
  image: string
  duration: number
  introTitleContent: string
  introductionContent: string
  summaryContent: string
  summaryAfterContent: string
  dynamicContent: string
  fixedContent: string
  timeContent: string
  questions: IQuizQuestion[]
  resources: IQuizResource[]
  currentQuestion: IQuizQuestion //This is not sent by the API, only for UI
  resume: boolean //This is not sent by the API, only for UI
}

export interface IQuizQuestion {
  sequence: number
  textId: string
  image: string
  options: IQuizOption[]
  checkboxes?: boolean
  content: string
  altContent: string
  correctFeedbackContent: string
  retryFeedbackContent: string
  failureFeedbackContent: string
  maybeFeedbackContent: string
  almostRightFeedbackContent: string
  maxCorrect: number
  failureResourcesContent: IQuizResource[]
}

export interface IQuizResource {
  id: string
  link: string
  content: string
}

export interface IQuizOption {
  quizId: number
  id: number
  questionId: string
  textId: string
  content: string
  ref?: any //This is only used by the UI
  multiselect?: boolean //This is only used by the UI
  selected: boolean //This is only used by the UI
}

export interface IQuizAnswerSelection {
  options: IQuizOption[]
  showFeedback: boolean
  answeredCorrect: boolean
  almostCorrect: boolean
  maybeAnsweredCorrect: boolean
  retryAnswer: boolean
}

export interface IGlossary {
  name: string
  title: string
  value: string
}

export interface IQuizAnswerRequest {
  quizId: number
  textId: string
  selection: string[]
}
export interface IQuestionAnswerResponse {
  isCorrect: boolean
  isMayBe: boolean
  isAlmostCorrect: boolean
}

export class QuizAnswerRequest implements IQuizAnswerRequest {
  quizId: number
  textId: string
  selection: string[]
}
